<umkt-auth-layout scrollable>
  <div class="auth-back">
    <a (click)="goBack()" style="cursor: pointer;">
      <mat-icon style="margin-right: 8px;">chevron_left</mat-icon>
      {{ 'shared.buttons.back' | i18n }}
    </a>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 class="title-text font-highlight">
            {{ 'pages.segmentSelection.title' | i18n }}
          </h1>
          <p class="subtitle-text">
            {{ 'pages.segmentSelection.subtitle' | i18n }}
          </p>
        </div>

        <!-- Search Bar -->
        <div class="search-container">
          <div class="search-input-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              type="text"
              [placeholder]="'pages.segmentSelection.searchPlaceholder' | i18n"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              class="search-input"
            >
            <mat-icon
              *ngIf="searchTerm"
              class="clear-icon"
              (click)="clearSearch()"
              style="cursor: pointer;"
            >close</mat-icon>
          </div>
        </div>

        <umkt-loading
          *ngIf="isBusy"
          [isLoading]="true"
          [size]="'md'"
          [mode]="'contained'"
          [showText]="true"
          [text]="'shared.messages.loading' | i18n"
        ></umkt-loading>

        <div *ngIf="!isBusy" class="segment-selection-content">
          <!-- MOBILE -->
          <div class="segment-group" *ngIf="filteredMobileItems.length > 0">
            <div class="segment-group-title">
              <span class="mdn-Icon-celular mdn-Icon--md segment-group-icon" aria-label="celular"></span>
              <span class="segment-group-title-text">{{ 'pages.segmentSelection.groups.mobile' | i18n }}</span>
            </div>

            <div class="segment-list" [class.scrollable]="filteredMobileItems.length > 4">
              <div
                *ngFor="let item of filteredMobileItems; trackBy: trackByItem"
                class="segment-option"
                (click)="selectMobile(item)"
              >
                <div class="segment-info" *ngIf="item.kind === 'MOBILE'">
                  <div class="segment-number">
                    {{ item.document }}
                  </div>
                  <div class="segment-subtitle">
                    {{ item.companyName || '' }}
                  </div>
                </div>
                <div class="segment-arrow">
                  <mat-icon class="arrow-icon">chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- FIXA -->
          <div class="segment-group" *ngIf="filteredFixaItems.length > 0">
            <div class="segment-group-title">
              <span class="mdn-Icon-modem mdn-Icon--md segment-group-icon" aria-label="modem"></span>
              <span class="segment-group-title-text">{{ 'pages.segmentSelection.groups.fixa' | i18n }}</span>
            </div>

            <div class="segment-list" [class.scrollable]="filteredFixaItems.length > 4">
              <div
                *ngFor="let item of filteredFixaItems; trackBy: trackByItem"
                class="segment-option"
                (click)="selectFixa(item)"
              >
                <div class="segment-info" *ngIf="item.kind === 'FIXA'">
                  <div class="segment-number">
                    {{ fixaContractLabel('' + item.contract.customerAccountId) }}
                  </div>
                  <div class="segment-details">
                    <span class="segment-status">{{ item.contract.status }}</span>
                    <span class="segment-separator">•</span>
                    <span class="segment-source">{{ item.contract.sourceSystemDescription }}</span>
                  </div>
                </div>
                <div class="segment-arrow">
                  <mat-icon class="arrow-icon">chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="filteredMobileItems.length === 0 && filteredFixaItems.length === 0" class="empty-state">
            <mat-icon class="empty-icon">search_off</mat-icon>
            <p class="empty-text">{{ 'pages.segmentSelection.empty.title' | i18n }}</p>
            <p class="empty-subtext">{{ 'pages.segmentSelection.empty.subtitle' | i18n }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <umkt-confirm-modal
    [open]="showLogoutConfirm"
    variant="danger"
    icon="bi bi-exclamation-triangle"
    [title]="'pages.registerMovel.logoutModal.title' | i18n"
    [message]="'pages.registerMovel.logoutModal.message' | i18n"
    (confirm)="handleLogoutConfirm()"
    (canceled)="handleLogoutCancel()"
    (closed)="handleLogoutCancel()"
    [confirmText]="'pages.registerMovel.logoutModal.confirm' | i18n"
    [cancelText]="'shared.buttons.cancel' | i18n"
  ></umkt-confirm-modal>
</umkt-auth-layout>

